(function() {
	'use strict';

	// GLOWEB-5050 A/B Test
	var $ = avm.require('cash'),
		$ab5050MessageBarMoreCtaElement = $('.js-more-devices-bar'),
		$ab5050MediaMoreCtaElement = $('.js-more-devices-media');

		$ab5050MessageBarMoreCtaElement.on('click', function() {
			dataLayer.push({
				"event": "av.genericEvent",
				"eventCategory": "CTA > Other",
				"eventAction": "Learn More - Top bar",
				"eventLabel": window.location.href
			});
		});

		$ab5050MediaMoreCtaElement.on('click', function() {
			dataLayer.push({
				"event": "av.genericEvent",
				"eventCategory": "CTA > Other",
				"eventAction": "Learn More - Bottom",
				"eventLabel": window.location.href
			});
		});
})();

// var sliderFeaturesWindows = tns({
// 	"container": ".slider-windows",
// 	"controlsContainer": ".slider-windows-controls",
// 	"preventScrollOnTouch": "force",
// 	"controlsPosition": "bottom",
// 	"controls": false,
// 	"navPosition": "bottom",
// 	"mouseDrag": true,
// 	"speed": 400,
// 	"fixedWidth": 288,
// 	"gutter": 32,
// 	"responsive": {
// 		"576": {
// 			"center": true
// 		},
// 		"768": {
// 			"items": 2,
// 			"slideBy": 2,
// 			"controls": true,
// 			"center": false
// 		},
// 		"1280": {
// 			"fixedWidth": 384
// 		},
// 		"1366": {
// 			"fixedWidth": 412
// 		},
// 		"1600": {
// 			"fixedWidth": 432
// 		}
// 	}
// });

// var sliderFeaturesMac = tns({
// 	"container": ".slider-mac",
// 	"controlsContainer": ".slider-mac-controls",
// 	"preventScrollOnTouch": "force",
// 	"controlsPosition": "bottom",
// 	"controls": false,
// 	"navPosition": "bottom",
// 	"mouseDrag": true,
// 	"speed": 400,
// 	"fixedWidth": 288,
// 	"gutter": 32,
// 	"responsive": {
// 		"576": {
// 			"center": true
// 		},
// 		"768": {
// 			"items": 2,
// 			"slideBy": 2,
// 			"controls": true,
// 			"center": false
// 		},
// 		"1280": {
// 			"fixedWidth": 384
// 		},
// 		"1366": {
// 			"fixedWidth": 412
// 		},
// 		"1600": {
// 			"fixedWidth": 432
// 		}
// 	}
// });

// var sliderFeaturesAndroid = tns({
// 	"container": ".slider-android",
// 	"controlsContainer": ".slider-android-controls",
// 	"preventScrollOnTouch": "force",
// 	"controlsPosition": "bottom",
// 	"controls": false,
// 	"navPosition": "bottom",
// 	"mouseDrag": true,
// 	"speed": 400,
// 	"fixedWidth": 288,
// 	"gutter": 32,
// 	"responsive": {
// 		"576": {
// 			"center": true
// 		},
// 		"768": {
// 			"items": 2,
// 			"slideBy": 2,
// 			"controls": true,
// 			"center": false
// 		},
// 		"1280": {
// 			"fixedWidth": 384
// 		},
// 		"1366": {
// 			"fixedWidth": 412
// 		},
// 		"1600": {
// 			"fixedWidth": 432
// 		}
// 	}
// });

// var sliderFeaturesIphone = tns({
// 	"container": ".slider-iphone",
// 	"controlsContainer": ".slider-iphone-controls",
// 	"preventScrollOnTouch": "force",
// 	"controlsPosition": "bottom",
// 	"controls": false,
// 	"navPosition": "bottom",
// 	"mouseDrag": true,
// 	"speed": 400,
// 	"fixedWidth": 288,
// 	"gutter": 32,
// 	"responsive": {
// 		"576": {
// 			"center": true
// 		},
// 		"768": {
// 			"items": 2,
// 			"slideBy": 2,
// 			"controls": true,
// 			"center": false
// 		},
// 		"1280": {
// 			"fixedWidth": 384
// 		},
// 		"1366": {
// 			"fixedWidth": 412
// 		},
// 		"1600": {
// 			"fixedWidth": 432
// 		}
// 	}
// });
